import { Injectable, inject } from '@angular/core';
import { SimpleGlobalModalService } from '@brightside-web/desktop/data-access/core-services';

@Injectable({ providedIn: 'root' })
export class HardshipRequiredDocsModalService {
  private _modal = inject(SimpleGlobalModalService);

  /**
   * Half-sheet for selecting/uploading files.
   * You pass in what should happen when the user clicks the CTA.
   */
  openUploadModal(
    onConfirm: () => void | Promise<void>,
    onCancel?: () => void
  ): void {
    this._modal.createModal({
      displayCloseButton: true,
      eventName: 'hardship_halfsheet_upload',
      isError: false,
      size: 'medium',
      title: 'HARDSHIP_HALFSHEET_UPLOAD_TITLE',
      contentKey: 'HARDSHIP_HALFSHEET_UPLOAD_DESC',
      ctaKey: 'HARDSHIP_HALFSHEET_UPLOAD_CTA2',
      ctaAction: async () => {
        await onConfirm();
      },
      closeAction: () => {
        onCancel?.();
        this._modal.clearModal();
      },
      secondaryCtaAction: () => {
        onCancel?.();
        this._modal.clearModal();
      },
    });
  }

  openUploadReminderModal(
    onDelete: () => void,
    onKeep: () => void
  ): void {
    this._modal.createModal({
      displayCloseButton: true,
      eventName: 'hardship_halfsheet_upload_reminder',
      isError: false,
      size: 'medium',
      title: 'hardship_halfsheet_upload_reminder_title',
      contentKey: 'hardship_halfsheet_upload_reminder_desc',
      ctaKey: 'hardship_halfsheet_upload_reminder_cta1',
      ctaAction: () => {
        onDelete();
        this._modal.clearModal();
      },
      secondaryCtaKey: 'hardship_halfsheet_upload_reminder_cta2',
      secondaryCtaAction: () => {
        onKeep();
        this._modal.clearModal();
      },
    });
  }

  openDeleteModal(onDelete: () => void, onCancel: () => void): void {
    this._modal.createModal({
      displayCloseButton: true,
      eventName: 'hardship_halfsheet_delete',
      isError: false,
      size: 'medium',
      title: 'HARDSHIP_HALFSHEET_DELETE_TITLE',
      contentKey: 'HARDSHIP_HALFSHEET_DELETE_DESC',
      ctaKey: 'HARDSHIP_HALFSHEET_DELETE_CTA1',
      ctaAction: () => {
        onDelete();
        this._modal.clearModal();
      },
      secondaryCtaKey: 'HARDSHIP_HALFSHEET_DELETE_CTA2',
      secondaryCtaAction: () => {
        onCancel();
        this._modal.clearModal();
      },
    });
  }

  deleteRetry(onRetry: () => void, onCancel: () => void): void {
    this._modal.createGenericErrorModal(
      'hardship_doc_delete_error',
      onRetry
    );
  }
}
